import { Card, CardContent } from '@mui/material';
import React from 'react';
import NewPasswordComponent from './newPasswordComponent';
import Stack from '@mui/material/Stack';
import MDBox from 'components/MDBox';
import { resources } from 'oems/resources';

export default function ResetPasswordPage() {
  return (
    <Stack alignItems="center">
      <Card sx={{ my: 10, width: 400 }}>
        <CardContent>
          <MDBox component="img" src={resources.logoDarkImage} width="164px" sx={{ ml: 1, my: 1 }} />
          <NewPasswordComponent />
        </CardContent>
      </Card>
    </Stack>
  );
}
